import { useSelector } from 'react-redux'

function getMenuItems(region) {
  const totalChannels = useSelector(state => state.liveChannels.data?.totalResults ?? 0)
  const psEnabled = useSelector(state => state.featureFlags?.psEnabled)

  return ([
    {
      title: 'Home',
      url: '/',
    },
    ...(psEnabled ? [{
      title: 'Premier Sports',
      url: '/premiersports',
      featureFlag: 'psports', // temp hardcode
    }] : []),
    ...totalChannels > 0 ? [{
      title: 'Live TV',
      url: '/live',
    }] : [],
    {
      title: 'Categories',
      url: '/categories/dramas',
    },
    ...(totalChannels > 0 ? [{
      title: 'TV Guide',
      url: '/tvguide',
    }] : []),
    {
      title: 'My List',
      url: '/my-list',
    },
  ])
}

export default getMenuItems
